export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref6291.cc3f0b43.jpg";